import { DB_PREFIX, DB_PREFIX_VACCINATED } from './constants';

export default {
  [DB_PREFIX_VACCINATED]: {
    vaccinated: false,
  },
  [DB_PREFIX]: {
    vaccineType: '',
    vaccineDateFirst: '',
    vaccineDateSecond: '',
  },
};